import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutCarrierTargetRateList } from "./autogen/AutogenLayoutCarrierTargetRateList";

export class CarrierTargetRateList extends AutogenLayoutCarrierTargetRateList {

    onLoad(): void | Promise<void> {
        this.tableCarrierTargetRate.addButtonCaption = "Add Carrier Target Rate";
    }

    sourceCarrierRateBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.target_rate = 'Y';
    }
    
}
